import * as React from "react";
import { forwardRef } from "react";
const SvgWise = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m3 13.848 4.87-5.69L4.91 3H21l-6.233 17.121h-3.532l5.161-14.205h-6.66l1.48 2.548v.07l-2.274 2.631h3.73l-.977 2.684H3Z" }));
const ForwardRef = forwardRef(SvgWise);
export default ForwardRef;
